import React from 'react';

interface PaginationProps {
  page: number;
  lastPage: number;
  onPageChange: (page: number) => void;
  disabled?: boolean;
}

const Pagination: React.FC<PaginationProps> = ({ page, lastPage, onPageChange, disabled = false }) => {
  if (lastPage <= 1) return null;

  return (
    <div className="flex items-center space-x-1">
      {Array.from({ length: lastPage }, (_, i) => i + 1)
        .filter(p => p === 1 || p === lastPage || Math.abs(p - page) <= 1)
        .reduce<(number | '...')[]>((acc, p, idx, arr) => {
          if (idx > 0 && p - (arr[idx - 1] as number) > 1) acc.push('...');
          acc.push(p);
          return acc;
        }, [])
        .map((p, idx) =>
          p === '...' ? (
            <span key={`ellipsis-${idx}`} className="px-2 text-gray-500">...</span>
          ) : (
            <button
              key={p}
              type="button"
              onClick={() => onPageChange(p)}
              disabled={p === page || disabled}
              className={`px-3 py-1 text-sm border rounded-md ${
                p === page
                  ? 'bg-green-600 text-white border-green-600'
                  : 'border-gray-300 hover:bg-gray-50'
              }`}
            >
              {p}
            </button>
          )
        )}
    </div>
  );
};

export default Pagination;
